<template>
	<div class="mh-middle">
		<div class="mh-middle-inner">
			<ContentTitle title="Dashboard" :data="alerts" />

			<b-row class="mh-chart">
				<b-col lg="12" xs="12">
					<b-card class="mh-card" body-class="py-0">
						<b-row no-gutters>
							<b-col>
								<div class="mh-entries-nav-container">
									<div class="mh-time-entries-nav">
										<span @click="changeDate(-1)"><i class="mh-icon-left"></i></span>
										<span>
											<b-dropdown size="lg" variant="link" class="schedule-calendar" ref="calendarDropdown" no-caret>
												<template slot="button-content">
													{{`${moment(this.date).format("DD MMM")} - ${moment(this.date).add(-1, "days").add(2, "weeks").format("DD MMM")}`}}
												</template>

												<b-dropdown-form>
													<b-calendar v-model="date" :hide-header="true" :value-as-date="true" @selected="onDateChange()"></b-calendar>
												</b-dropdown-form>
											</b-dropdown>
										</span>
										<span @click="changeDate(1)"><i class="mh-icon-right"></i></span>
									</div>
								</div>
							</b-col>
						</b-row>
						<b-row class="charts">
							<b-col :lg="this.windowWidth > 768 ? 'auto': null" :cols="this.windowWidth > 768 ? 'auto' : 4" :class="`${this.windowWidth > 768 ? '' : 'small '}p-0`">
								<div id="allotedhours" class="chart" ref="allotedHoursChart"></div>
								<div class="mh-chart-clock"><i class="mh-icon-watch"></i></div>
								<h3>Today's Allotted Hours</h3>
							</b-col>
							<b-col :lg="this.windowWidth > 768 ? 'auto': null" :cols="this.windowWidth > 768 ? 'auto' : 4" :class="`${this.windowWidth > 768 ? '' : 'small '}p-0`">
								<div id="completedhours" class="chart" ref="completedHoursChart"></div>
								<div class="mh-chart-clock green"><i class="mh-icon-watch"></i></div>
								<h3>Today's Completed Hours</h3>
							</b-col>
							<b-col :lg="this.windowWidth > 768 ? 'auto': null" :cols="this.windowWidth > 768 ? 'auto' : 4" :class="`${this.windowWidth > 768 ? '' : 'small '}p-0`">
								<div id="fortnightlyTravelKms" class="chart" ref="fortnightlyTravelKmsChart"></div>
								<div class="mh-chart-clock green"><i class="mh-icon-watch"></i></div>
								<h3>Fortnightly Travel KMs</h3>
							</b-col>
							<b-col :lg="this.windowWidth > 768 ? 'auto': null" :cols="this.windowWidth > 768 ? 'auto' : 4" :class="`${this.windowWidth > 768 ? '' : 'small '}p-0`">
								<div id="fortnightlyAllotedHours" class="chart" ref="fortnightlyAllotedHoursChart"></div>
								<div class="mh-chart-clock"><i class="mh-icon-watch"></i></div>
								<h3>Fortnightly Allotted Hours</h3>
							</b-col>
							<b-col :lg="this.windowWidth > 768 ? 'auto': null" :cols="this.windowWidth > 768 ? 'auto' : 4" :class="`${this.windowWidth > 768 ? '' : 'small '}p-0`">
								<div id="fortnightlyCompletedHours" class="chart" ref="fortnightlyCompletedHoursChart"></div>
								<div class="mh-chart-clock green"><i class="mh-icon-watch"></i></div>
								<h3>Fortnightly Completed Hours</h3>
							</b-col>
						</b-row>
					</b-card>
				</b-col>
			</b-row>

			<b-row>
				<b-col lg="6" xs="12" style="z-index:0;">
					<b-card no-body class="mh-card">
						<b-card-header>
							<h3 class="card-title">Available Shifts</h3>
						</b-card-header>
						<b-card-body>
							<div class="mh-shift-list">
								<b-nav v-if="availableShifts.length > 0" vertical>
									<b-nav-item v-for="(availableShift, index) in availableShifts" :key="index">
										<label class="mh-list-label">{{availableShift.clientfullname}}</label>
										<div class="mh-list-content">
											<label>{{availableShift.clientfulladdress}}</label>
											<a href="#" class="mh-list-title">{{availableShift.shifttask}}</a>
											<div class="d-flex">
												<div class="mh-formTo-time">{{moment(availableShift.servicedate, "DD/MM/YYYY h:mm:ss A").format("ddd, DD MMM YYYY")}} <b>{{availableShift.shift}}</b></div>
												<div class="mh-list-time ml-auto">{{availableShift.shifttotalhours}} Hrs</div>
											</div>
											<div class="w-100 p-0 text-right">
												<b-button @click="pickupShift(availableShift)" class="btn-default btn-green scaled70 m-0">Pickup</b-button>
											</div>
										</div>
									</b-nav-item>
								</b-nav>
								<b-nav v-else vertical>
									<b-nav-item>
										<label class="mh-list-label">There are no shifts to display</label>
									</b-nav-item>
								</b-nav>
							</div>
						</b-card-body>
					</b-card>
				</b-col>
				<b-col lg="6" xs="12">
					<TimeClock :records="timeClockShifts" @save-clockin-form="refreshData" @save-clockout-form="refreshData" />
				</b-col>
			</b-row>
			<b-row>
				<b-col lg="6" xs="12">
					<b-card no-body class="mh-card">
						<b-card-header>
							<h3 class="card-title">Today's Shifts</h3>
						</b-card-header>
						<b-card-body>
							<div class="mh-shift-list">
								<b-nav v-if="todaysShifts.length > 0" vertical>
									<b-nav-item v-for="(todaysShift, index) in todaysShifts" :key="index">
										<label class="mh-list-label">{{todaysShift.clientfullname}}</label>
										<div class="mh-list-content">
											<a v-if="todaysShift.istimeclock" href="#" class="mh-list-title" v-html="`${todaysShift.shifttask}${(todaysShift.servicetypename == '' ? '' : ' - ' + todaysShift.servicetypename)}`"></a>
											<a v-else href="#" class="mh-list-title">{{todaysShift.shifttask}}</a>
											<div class="d-flex">
												<div class="mh-formTo-time">{{todaysShift.shift}}</div>
												<div class="mh-list-time ml-auto">{{todaysShift.totalhours}} Hrs</div>
											</div>
										</div>
									</b-nav-item>
								</b-nav>
								<b-nav v-else vertical>
									<b-nav-item>
										<label class="mh-list-label">There are no shifts to display</label>
									</b-nav-item>
								</b-nav>
							</div>
						</b-card-body>
					</b-card>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
	import ContentTitle from "./partials/ContentTitle"
	import TimeClock from "./partials/TimeClock"
	import moment from "moment"

	import bb, { gauge } from "billboard.js"
	import "billboard.js/dist/theme/insight.css"

	export default {
		name: 'DashboardContent',
		components: {
			ContentTitle,
			TimeClock
		},
		data: function () {
			return {
				date: new Date(),
				windowWidth: 0,
				allotedHoursChart: null,
				completedHoursChart: null,
				fortnightlyAllotedHoursChart: null,
				fortnightlyCompletedHoursChart: null,
				fortnightlyTravelKmsChart: null
			}
		},
		mounted: function () {
			this.date = this.dateFrom

			if (this.customers.length > 0)
				this.refreshData()

			this.$store.dispatch("Shifts/getAvailableShifts")

			this.$store.dispatch("Intervals/set", { name: "DashboardRefreshData", callback: this.refreshData, timeout: 60000 })
			this.windowWidth = window.innerWidth

			window.addEventListener('resize', () => {
				this.windowWidth = window.innerWidth

				this.generateCharts()
			})
		},
		destroyed: function () {
			this.$store.commit("Intervals/clear", "DashboardRefreshData")

			if (this.allotedHoursChart != null)
				this.allotedHoursChart.destroy()

			if (this.completedHoursChart != null)
				this.completedHoursChart.destroy()

			if (this.fortnightlyAllotedHoursChart != null)
				this.fortnightlyAllotedHoursChart.destroy()

			if (this.fortnightlyCompletedHoursChart != null)
				this.fortnightlyCompletedHoursChart.destroy()

			if (this.fortnightlyTravelKmsChart != null)
				this.fortnightlyTravelKmsChart.destroy()
		},
		watch: {
			customers: {
				immediate: true,
				handler(newValue, oldValue) {
					if (newValue.length > 0) {
						this.refreshData()
					}
				}
			}
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			shifts: function () {
				return this.$store.state.Shifts.shifts
			},
			availableShifts: function () {
				return this.$store.state.Shifts.availableShifts
			},
			customers: function () {
				return this.$store.state.Customers.customers
			},
			timeClockShifts: function () {
				return this.$store.state.Shifts.timeClockShifts
			},
			isEmployee: function () {
				return this.profile.accounttype == 2
			},
			dateFrom: function () {
				return this.$store.state.Shifts.date
			},
			todaysShifts: function () {
				return this.shifts
					.filter(x => {
						return moment(x.servicedate, "DD/MM/YYYY h:mm:ss A").startOf("day").isSame(moment().startOf("day"))
							&& x.employeeid == this.profile.userid
					})
			},
			alerts: function () {
				return this.$store.state.Alerts.alerts.map(x => x.alert)
			},
			todaysAllotedHours: function () {
				return this.todaysShifts.map(x => parseFloat(x.totalhours)).reduce(function (a, b) {
					return a + b
				}, 0)
			},
			todaysCompletedHours: function () {
				var completedHours = this.todaysShifts.map(x => parseFloat("0" + x.timesheettotalhours)).reduce(function (a, b) {
					return a + b
				}, 0)

				return (completedHours / this.todaysAllotedHours) * 100
			},
			fortnightlyShifts: function () {
				return this.shifts
					.filter(x => {
						return moment(x.servicedate, "DD/MM/YYYY h:mm:ss A")
							.startOf("day")
							.isBetween(moment(this.date).startOf("day"), moment(this.date).add(-1, "days").add(2, "weeks").startOf("day"), undefined, [])
							&& x.employeeid == this.profile.userid
					})
			},
			fortnightlyAllotedHours: function () {
				return this.fortnightlyShifts.map(x => parseFloat(x.totalhours)).reduce(function (a, b) {
					return a + b
				}, 0)
			},
			fortnightlyCompletedHours: function () {
				var completedHours = this.fortnightlyShifts.map(x => parseFloat("0" + x.timesheettotalhours)).reduce(function (a, b) {
					return a + b
				}, 0)

				return completedHours
			},
			fortnightlyTravelKms: function () {
				var fortnightlyTravelKms = this.fortnightlyShifts.map(x => parseFloat("0" + x.timesheettraveldistance)).reduce(function (a, b) {
					return a + b
				}, 0)

				return fortnightlyTravelKms
			}
		},
		methods: {
			onDateChange() {
				this.$refs.calendarDropdown.hide()

				this.$store.commit("Shifts/setDate", this.date)

				this.refreshData()
			},
			changeDate(i) {
				this.date = moment(this.date).add(2 * i, "weeks").toDate()

				this.$store.commit("Shifts/setDate", this.date)

				this.refreshData()
			},
			pickupShift(shift) {
				this.$store.commit("Confirmation/show", {
					text: `Are you sure you want to pickup the shift for <b>${shift.clientfullname}</b> on <b>${moment(shift.servicedate, "DD/MM/YYYY h:mm:ss A").format("ddd,DD MMM YYYY h:mm a")}</b> to <b>${moment(shift.serviceenddate, "DD/MM/YYYY h:mm:ss A").format("ddd,DD MMM YYYY h:mm a")}</b>?`,
					okCallback: () => {
						this.$store.dispatch(
							"Shifts/pickupShift",
							shift.servicescheduleid)
							.then(() => {
								this.$store.commit("Toasts/showSuccess", { title: "Assigned", content: "Shift assigned" })
								this.$store.dispatch("Shifts/getAvailableShifts")
							})
					},
					cancelCallback: null
				})
			},
			refreshData: function () {
				var $this = this

				this.$store.dispatch(
					"Shifts/getShiftsForRange",
					{
						fromDate: moment(this.date).format('YYYY-MM-DD'),
						toDate: moment(this.date).add(-1, "days").add(2, "weeks").format('YYYY-MM-DD'),
						showLoading: false
					}
				).then(function () {
					if ($this.isEmployee)
						$this.generateCharts()
				})
			},
			generateCharts: function () {
				if (this.allotedHoursChart != null) {
					this.allotedHoursChart.destroy()
				}
				
				var width = 10;
				var height = 90;

				if (this.windowWidth > 768) {
					width = 20;
					height = 200;
				}
				
				this.allotedHoursChart = bb.generate({
					data: {
						columns: [
							["Today's Alloted Hours", this.todaysAllotedHours.toFixed(1)]
						],
						type: gauge(),
						colors: {
							"Today's Alloted Hours": "#E94A79"
						},
					},
					gauge: {
						background: "#F2F4F9",
						max: 7.5,
						fullCircle: true,
						label: {
							format: function (value, ratio) { return value + "\nhours"; },
							extents: () => "",
							colors: "#E94A79",
						},
						width: width,
						expand: true
					},
					bindto: this.$refs.allotedHoursChart,
					onafterinit: function () {
						this.resize({
							height: height
						})
					}
				});

				this.allotedHoursChart.legend.hide();

				if (this.completedHoursChart != null) {
					this.completedHoursChart.destroy()
				}

				this.completedHoursChart = bb.generate({
					data: {
						columns: [
							["Today's Completed Hours", this.todaysCompletedHours.toFixed(1)]
						],
						type: gauge(),
						colors: {
							"Today's Completed Hours": "#5ABA47"
						},
					},
					gauge: {
						background: "#F2F4F9",
						fullCircle: true,
						label: {
							extents: () => "",
							colors: "#5ABA47",
						},
						width: width,
						expand: true
					},
					bindto: this.$refs.completedHoursChart,
					onafterinit: function () {
						this.resize({
							height: height
						})
					}
				});

				this.completedHoursChart.legend.hide();

				if (this.fortnightlyAllotedHoursChart != null) {
					this.fortnightlyAllotedHoursChart.destroy()
				}

				this.fortnightlyAllotedHoursChart = bb.generate({
					data: {
						columns: [
							["Fortnightly Alloted Hours", this.fortnightlyAllotedHours.toFixed(1)]
						],
						type: gauge(),
						colors: {
							"Fortnightly Alloted Hours": "#E94A79"
						},
					},
					gauge: {
						background: "#F2F4F9",
						max: 37.5,
						fullCircle: true,
						label: {
							format: function (value, ratio) { return value + "\nhours"; },
							extents: () => "",
							colors: "#E94A79",
						},
						width: width,
						expand: true
					},
					bindto: this.$refs.fortnightlyAllotedHoursChart,
					onafterinit: function () {
						this.resize({
							height: height
						})
					}
				});

				this.fortnightlyAllotedHoursChart.legend.hide();

				if (this.fortnightlyCompletedHoursChart != null) {
					this.fortnightlyCompletedHoursChart.destroy()
				}

				this.fortnightlyCompletedHoursChart = bb.generate({
					data: {
						columns: [
							["Weekly Completed Hours", this.fortnightlyCompletedHours.toFixed(1)]
						],
						type: gauge(),
						colors: {
							"Weekly Completed Hours": "#5ABA47"
						},
					},
					gauge: {
						background: "#F2F4F9",
						fullCircle: true,
						label: {
							extents: () => "",
							colors: "#5ABA47",
						},
						width: width,
						expand: true
					},
					bindto: this.$refs.fortnightlyCompletedHoursChart,
					onafterinit: function () {
						this.resize({
							height: height
						})
					}
				});

				this.fortnightlyCompletedHoursChart.legend.hide();

				if (this.fortnightlyTravelKmsChart != null) {
					this.fortnightlyTravelKmsChart.destroy()
				}

				this.fortnightlyTravelKmsChart = bb.generate({
					data: {
						columns: [
							["Fortnightly Travel KMs", this.fortnightlyTravelKms.toFixed(1)]
						],
						type: gauge(),
						colors: {
							"Fortnightly Travel KMs": "#6779f5"
						},
					},
					gauge: {
						background: "#F2F4F9",
						fullCircle: true,
						label: {
							format: function (value, ratio) { return value + "\nKMs"; },
							extents: () => "",
							colors: "#6779f5",
						},
						width: width,
						expand: true
					},
					bindto: this.$refs.fortnightlyTravelKmsChart,
					onafterinit: function () {
						this.resize({
							height: height
						})
					}
				});

				this.fortnightlyTravelKmsChart.legend.hide();
			}
		}
	};
</script>

<style>
	.dropdown-menu.show {
		z-index: 1;
	}
</style>
<style scoped>
	@import 'https://cdn.jsdelivr.net/npm/billboard.js/dist/billboard.min.css';

	.card.mh-card.mh-card-TimeClock-page {
		padding: 0px !important;
	}

	@media (min-width: 1366px) {
		.charts .col-lg-auto {
			-ms-flex-preferred-size: 0;
			flex-basis: 0;
			-webkit-box-flex: 1;
			-ms-flex-positive: 1;
			flex-grow: 1;
			min-width: 0;
			max-width: 100%;
		}
	}

	.card.mh-card .card-header {
		padding: 20px 25px 20px;
	}
</style>